ceregoLayoutApp.factory('V3LtiConfirmationMailerResource', ['$resource', ($resource) ->
  $resource "", {},
    create:
      method: 'POST'
      isArray: false
      url: APIRoutes.v3_lti_confirmation_mailer_path()
      params:
        email_address: "@email_address"
])
